import { getModelForStats } from '@/shared/plugins/stats/helpers';

export default class StatsEmit {
  constructor() {
    this.emitters = [];
  }

  callEmitters(functionName, params) {
    this.emitters.forEach((emitter) => emitter.callEvent(functionName, params));
  }

  registerEmitter(emitter) {
    this.emitters.push(emitter);
  }

  addToFavorites(product) {
    this.callEmitters('addToFavorites', { product });
  }

  changeLanguage(language) {
    this.callEmitters('changeLanguage', { language });
  }

  bufferingWhilePlaying(product, playerCurrentTime, bufferingDuration, adParams) {
    this.callEmitters('bufferingWhilePlaying', {
      adParams,
      bufferingDuration,
      playerCurrentTime,
      product: getModelForStats(product),
    });
  }

  clickModal(params) {
    this.callEmitters('clickModal', params);
  }

  closeModal(params) {
    this.callEmitters('closeModal', params);
  }

  showModal(params) {
    this.callEmitters('showModal', params);
  }

  changePlayingSettings(quality, product) {
    this.callEmitters('changePlayingSettings', {
      quality,
      product: getModelForStats(product),
    });
  }

  changeProfile(previousProfile, currentProfile) {
    this.callEmitters('changeProfile', { previousProfile, currentProfile });
  }

  errorWhilePlaying(product, playerCurrentTime, errorCode) {
    this.callEmitters('errorWhilePlaying', {
      errorCode,
      playerCurrentTime,
      product: getModelForStats(product),
    });
  }

  login({ isAutoLogin }) {
    this.callEmitters('login', { isAutoLogin });
  }

  logout({ id, profile }) {
    this.callEmitters('logout', { id, profile });
  }

  pausePlaying(product, playerCurrentTime) {
    this.callEmitters('pausePlaying', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  pageView(pagePath, product) {
    this.callEmitters('pageView', { pagePath, product });
  }

  showSignUpForm() {
    this.callEmitters('showSignUpForm');
  }

  startPlaying(product, playerCurrentTime) {
    this.callEmitters('startPlaying', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  stopPlaying(product, playerCurrentTime) {
    this.callEmitters('stopPlaying', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  closePlayer(product, playerCurrentTime) {
    this.callEmitters('closePlayer', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  complete(product) {
    this.callEmitters('complete', {
      product: getModelForStats(product),
    });
  }

  play(product, playerCurrentTime) {
    this.callEmitters('play', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  playNext(product) {
    this.callEmitters('playNext', {
      product: getModelForStats(product),
    });
  }

  seek(product, playerCurrentTime) {
    this.callEmitters('seek', {
      product: getModelForStats(product),
      playerCurrentTime,
    });
  }

  search(keyword) {
    this.callEmitters('search', { keyword });
  }

  videoProgress(product, params) {
    this.callEmitters('videoProgress', {
      product: getModelForStats(product),
      params,
    });
  }

  adClick(adParams, product) {
    this.callEmitters('adClick', {
      adParams,
      product: getModelForStats(product),
    });
  }

  adFinish(adParams, product) {
    this.callEmitters('adFinish', {
      adParams,
      product: getModelForStats(product),
    });
  }

  adStart(adParams, product) {
    this.callEmitters('adStart', {
      adParams,
      product: getModelForStats(product),
    });
  }
}
